var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54 1.5H2.8275C2.09434 1.5 1.5 2.09434 1.5 2.8275V6.54C1.5 7.27316 2.09434 7.8675 2.8275 7.8675H6.54C7.27316 7.8675 7.8675 7.27316 7.8675 6.54V2.8275C7.8675 2.09434 7.27316 1.5 6.54 1.5Z",
    fill: "#BBBBBB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1725 1.5H11.46C10.7268 1.5 10.1325 2.09434 10.1325 2.8275V6.54C10.1325 7.27316 10.7268 7.8675 11.46 7.8675H15.1725C15.9057 7.8675 16.5 7.27316 16.5 6.54V2.8275C16.5 2.09434 15.9057 1.5 15.1725 1.5Z",
    fill: "#BBBBBB"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.165 10.125H11.4525C10.7193 10.125 10.125 10.7193 10.125 11.4525V15.165C10.125 15.8982 10.7193 16.4925 11.4525 16.4925H15.165C15.8982 16.4925 16.4925 15.8982 16.4925 15.165V11.4525C16.4925 10.7193 15.8982 10.125 15.165 10.125Z",
    fill: "#BBBBBB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.54 10.125H2.8275C2.09434 10.125 1.5 10.7193 1.5 11.4525V15.165C1.5 15.8982 2.09434 16.4925 2.8275 16.4925H6.54C7.27316 16.4925 7.8675 15.8982 7.8675 15.165V11.4525C7.8675 10.7193 7.27316 10.125 6.54 10.125Z",
    fill: "#BBBBBB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.6e687dafb363eb4db37aefd98a332f5f.svg";
export { ForwardRef as ReactComponent };